var React = require('react');

function XMenuButton (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"12.9991","y1":"0.65801","x2":"0.753027","y2":"14.6721","stroke":"white","strokeWidth":"2","key":0}),React.createElement("line",{"x1":"0.707107","y1":"1.29289","x2":"13.8669","y2":"14.4527","stroke":"white","strokeWidth":"2","key":1})]);
}

XMenuButton.defaultProps = {"width":"17","height":"18","viewBox":"0 0 15 16","fill":"none"};

module.exports = XMenuButton;

XMenuButton.default = XMenuButton;
